/**
 * SPA 클라이언트 라우팅 네비게이션 유틸리티
 * @param {string} to
 */
export function navigateTo(to) {
  if (window.location.pathname !== to) {
    window.history.pushState({}, '', to);
    window.dispatchEvent(new PopStateEvent('popstate'));
    window.scrollTo(0, 0);
  }
}
